import { Logger } from './Logger';
export class WithLogger {
    constructor(loggerKey) {
        this.logger = new Logger(loggerKey);
    }
}
